import React from 'react';
import { IOldIconProps } from './type';

const Filter: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 9H10c1.222 1.304 3.081 3.859 3.667 6.522V24l3.666-3.26c-.047-1.215 0-1.957 0-5.218.376-2.357 2.36-4.85 3.667-6.522z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Filter;
